import { render, staticRenderFns } from "./CompanyCenter.vue?vue&type=template&id=0598bb28&scoped=true"
import script from "./CompanyCenter.vue?vue&type=script&lang=js"
export * from "./CompanyCenter.vue?vue&type=script&lang=js"
import style0 from "./CompanyCenter.vue?vue&type=style&index=0&id=0598bb28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0598bb28",
  null
  
)

export default component.exports